module.exports = __webpack_public_path__ + "static/media/PDF_52.710a0a1a.pdf";